import React from 'react';

import { locationLoader } from '@/core/router/loaders/locationLoader';
import FindReservation from '@/core/screens/find-reservation';
import MoveIn from '@/core/screens/move-in';
import MoveInConfirmed from '@/core/screens/move-in-confirmed';
import ReservationWithFee from '@/core/screens/reservation-with-fee';
import BookingConfirmed from '@/journey-based-listing/screens/booking-confirmed';
import Error from '@/journey-based-listing/screens/error';

export const wizardScreens = [
    {
        path: 'find-reservation',
        element: <FindReservation />,
        loader: locationLoader,
        errorElement: <Error />,
    },
    {
        path: 'find-reservation/:reference',
        element: <FindReservation />,
        loader: locationLoader,
        errorElement: <Error />,
    },
    {
        path: 'booking-confirmed/:token',
        element: <BookingConfirmed />,
        loader: locationLoader,
        errorElement: <Error />,
    },
    {
        path: 'reservation-with-fee/:token',
        element: <ReservationWithFee />,
        loader: locationLoader,
        errorElement: <Error />,
    },
    {
        path: 'reservation-with-fee/:token/return',
        element: <ReservationWithFee />,
        loader: locationLoader,
        errorElement: <Error />,
    },
    {
        path: 'move-in/:token',
        element: <MoveIn />,
        loader: locationLoader,
        errorElement: <Error />,
    },
    {
        path: 'move-in/:token/oauth-return',
        element: <MoveIn oAuthReturn />,
        loader: locationLoader,
        errorElement: <Error />,
    },
    {
        path: 'move-in-confirmed/:token',
        element: <MoveInConfirmed />,
        loader: locationLoader,
        errorElement: <Error />,
    },
];
